<template>
	<BaseLink
		:link="{ router: 'view-offering-details', params: { offeringId: props.data?.fund?.fundriseId } }"
		class="asset-details-associated-fund-card module module--on-white-bg"
		@focusin="isHovered = true"
		@focusout="isHovered = false"
		@mouseover="isHovered = true"
		@mouseout="isHovered = false"
	>
		<div class="display-flex align-items-center gap-100 p-100" data-test="asset-details-associated-fund-card">
			<div
				><div class="display-flex flex-direction-column-reverse-smo gap-100 gap-50-smo">
					<div class="body-lg font-weight-bold">{{ props.data.fund.name }}</div>
					<div>
						<StatusTag v-if="fundStatusLabel" :text="fundStatusLabel" :background="fundStatusBackground" />
						<Tag :text="props.data.fund.assetClass.label" :background="tagBackground" />
					</div>
				</div>
				<div class="summary line-clamp-3 mt-25 text-color-gray-80">{{ props.data.fund.fundSummary }}</div></div
			>
			<BaseSvgIcon role="presentation" class="arrow" name="chevron" dir="right" width="24" height="24" />
		</div>
	</BaseLink>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { AssetFundAllocation } from 'types/assets';
import StatusTag from '@components/tags/status-tag.vue';
import Tag from '@components/tags/tag-component.vue';
import { TagBackground } from 'types/layout';

interface Props {
	data: AssetFundAllocation;
}

const props = defineProps<Props>();

const isHovered = ref(false);

const fundStatusLabel = computed((): string => props.data.fund.offeringAvailabilityStatus?.label ?? '');

const fundStatusBackground = computed((): TagBackground => {
	switch (props.data.fund.offeringAvailabilityStatus?.name) {
		case 'OPEN':
			return 'green';
		case 'COMING_SOON':
			return 'blue';
		case 'CLOSED':
			return isHovered.value ? 'white' : 'default';
		default:
			return 'default';
	}
});

const tagBackground = computed((): TagBackground => (isHovered.value ? 'white' : 'default'));
</script>

<style lang="scss">
@use '../../../styles/constants/colors.scss' as *;

.asset-details-associated-fund-card {
	color: currentColor;
	margin-top: 0;

	.arrow {
		color: gray(40);
	}

	&:hover {
		color: token('content-primary');
		background-color: token('bg-secondary');
		border: 1px solid transparent;
		box-shadow: 0 0 0 2px token('content-primary');

		.summary {
			color: token('content-primary');
		}

		.arrow {
			color: token('content-primary');
		}
	}
}
</style>
